<template>
  <div class="container">
  </div>
</template>

<script>
  export default {
    data() {
      return {

      }
    },
    created() {
      let type = this.getUrlKey("type")
      let code = this.getUrlKey("code")
      let state = this.getUrlKey("state")
      this.getWeixin(type, code, state)
    },
    methods: {
      getUrlKey(name) {
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [,
          ""
        ])[1].replace(/\+/g, '%20')) || null;
      },
      // 通过code获取微信信息
      getWeixin(type, code, state) {
        this.$axios({
          method: 'post', // 请求格式
          url: '/api/login/weappLogin', // 请求路径
          headers: { // 设置请求头
            token: this.$cookieStore.getCookie('token')
          },
          data: {
            code: code,
            type: type
          }
        }).then(res => {
          // 告诉父组件准备好接收消息了
          const x = {
            cmd: 'ready-for-receiving',
            message: res.data.msg,
            code: res.data.code
          };
          //转化为json字符串，兼容低版本浏览器
          const data = JSON.stringify(x);
          window.parent.postMessage(data, '*');
          if (type == 1) {
            // 如果登陆成功，存储登录信息
            if (res.data.code == 200) {
              this.$cookieStore.setCookie('token', res.data.data.token)
              this.$cookieStore.setCookie('userInfo', JSON.stringify(res.data.data.userInfo))
            }
          }else{
            
          }
        })
      }
    },
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/LoginSuccess.vue